import React from "react";
import { useLanguage } from "@/i18n";

const ProvidersSection = () => {
  const { t } = useLanguage();

  const openclawProvider = {
    name: t('providers.openclaw.name'),
    logo: "🔓",
    color: "from-green-400 to-teal-500",
    description: t('providers.openclaw.desc')
  };

  const otherProviders = [
    {
      name: t('providers.claude.name'),
      logo: "C",
      color: "from-orange-400 to-orange-600",
      description: t('providers.claude.desc')
    },
    {
      name: t('providers.ollama.name'),
      logo: "🦙",
      color: "from-primary to-accent",
      description: t('providers.ollama.desc')
    },
    {
      name: t('providers.openai.name'),
      logo: "⚡",
      color: "from-emerald-500 to-green-600",
      description: t('providers.openai.desc')
    },
    {
      name: t('providers.gemini.name'),
      logo: "✦",
      color: "from-blue-400 to-indigo-500",
      description: t('providers.gemini.desc')
    },
    {
      name: t('providers.openrouter.name'),
      logo: "⟐",
      color: "from-purple-400 to-violet-500",
      description: t('providers.openrouter.desc')
    },
    {
      name: t('providers.apple.name'),
      logo: "🍎",
      color: "from-gray-400 to-gray-600",
      description: t('providers.apple.desc')
    },
    {
      name: t('providers.kimi.name'),
      logo: "🌙",
      color: "from-sky-400 to-cyan-500",
      description: t('providers.kimi.desc')
    }
  ];

  return (
    <section id="providers" className="py-16 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <p className="text-muted-foreground text-sm uppercase tracking-widest mb-2">
            {t('providers.title')}
          </p>
          <p className="text-muted-foreground/70 text-xs mt-1">
            {t('providers.subtitle')}
          </p>
        </div>

        {/* OpenClaw featured card */}
        <div className="mb-6">
          <div className="group relative glass-card rounded-2xl p-8 text-center hover:border-green-400/30 transition-all duration-300 cursor-default border border-green-500/20 bg-green-500/5">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${openclawProvider.color} flex items-center justify-center text-3xl font-bold text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {openclawProvider.logo}
              </div>
              <div className="text-center sm:text-left">
                <h3 className="font-bold text-xl text-foreground mb-1">
                  {openclawProvider.name}
                </h3>
                <p className="text-sm text-muted-foreground">
                  {openclawProvider.description} — Skills, Missions, Cron, Molt Gateway
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Other providers grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 sm:gap-4">
          {otherProviders.map((provider, index) => (
            <div
              key={provider.name}
              className="group relative glass-card rounded-2xl p-4 text-center hover:border-primary/30 transition-all duration-300 cursor-default"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Logo */}
              <div className={`w-11 h-11 mx-auto mb-3 rounded-xl bg-gradient-to-br ${provider.color} flex items-center justify-center text-xl font-bold text-white shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                {provider.logo}
              </div>

              {/* Name */}
              <h3 className="font-semibold text-foreground text-sm mb-0.5">
                {provider.name}
              </h3>

              {/* Description */}
              <p className="text-xs text-muted-foreground">
                {provider.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProvidersSection;
